import { checkAuthority } from '@/utils/common';

export const CUSTOMCUL_EDITION_BOMDATA_CONF = {
  configName: '自定义列配置-版单物料数据',
  configKey: 'CustomColByEditionBOMData',
};
export const CUSTOMCUL_EDITION_LIST_CONF = {
  configName: '自定义列配置-版单列表',
  configKey: 'CustomColByEditionList',
};
// 版单记住查询条件的key
export const KEEP_QUERY_KEY = 'EDITION_ORDER_QUERY';

export const defaultSearchJson = {
  searchKey: '', // 名称、货号、条码
  storehouseId: '', // 仓库字段需确认
  categoryId: '', // 分类
  clientId: '', // 客户
  devTime: [], // 开发日期
  blandId: '', // 品牌
  year: '', // 年份
  month: '', // 月份
  seasonId: '', // 季节
  rangesId: '', // 波段
  sex: '', // 性别
  designer: '', // 设计师
  isOnSale: 1, // 启用状态
  warnNumberLow: null, // 最小库存
  warnNumberTop: null, // 最大库存
};

// 版单状态 进度状态 1-未开始 2-进行中 3-已结束 4-废版 9-撤销
export const ORDER_STATUS = {
  DIDNTSTART: 1, // 未开始
  PROCESSING: 2, // 进行中
  COMPLETE: 3, // 已结束
  PAPER_TRASH: 4, // 废版
  REVOKE: 9, // 撤销
  // 审批中
  AUDITING: 10,
  // 审批拒绝
  AUDIT_REJECT: 12,
} as const;
export type OrderStatus = ExtractObjVal<typeof ORDER_STATUS>;
export const ORDER_NODE_TEXT = {
  PATTERN: '纸样', // 纸样
};
export const ORDER_NODE_STATUS = {
  PATTERN_OVERDUE: 1, // 纸样逾期
  VEHICLE_OVERDUE: 2, // 车版逾期
};
// 审版状态
export const REVIEW_STATE = {
  NOT_REVIEW: 2, // 未设置审版
  REVIEWING: 3, // 待审
  REVIEWED: 4, // 已审
} as const;
export const REVIEW_STATE_OPTIONS = [
  {
    text: '未设置审版',
    val: REVIEW_STATE.NOT_REVIEW,
  },
  {
    text: '待审',
    val: REVIEW_STATE.REVIEWING,
  },
  {
    text: '已审',
    val: REVIEW_STATE.REVIEWED,
  },
];
export const WORK_PROCESS_AUDIT_STATE = [
  {
    text: '未开始',
    val: 0,
    color: 'orangered',
  },
  {
    text: '审批中',
    val: 10,
    color: '#007cff',
  },
  {
    text: '已同意',
    val: 11,
    color: 'green',
  },
  {
    text: '拒绝',
    val: 12,
    color: 'red',
  },
];
// 版单状态列表
export const ORDER_STATUS_OPTIONS = [
  {
    text: '默认',
    val: 0,
    freeze: true,
  },
  {
    val: ORDER_STATUS.AUDITING,
    text: '审批中',
    params: { state: ORDER_STATUS.AUDITING },
    orderCountField: 'approvalInProgressCount',
    color: 'orange',
    bg: '#FFF3E1',
    tc: '#FB9400',
  },
  {
    val: ORDER_STATUS.AUDIT_REJECT,
    text: '拒绝',
    params: { state: ORDER_STATUS.AUDIT_REJECT },
    color: 'orangeRed',
    bg: '#FFEFEC',
    tc: '#F37C64',
  },
  {
    text: '未开始',
    val: ORDER_STATUS.DIDNTSTART,
    orderCountField: 'notStartCount',
    color: 'orange',
    bg: '#ECF3FF',
    tc: '#007CFF',
  },
  {
    text: '未指派',
    val: 'noAssign',
    orderCountField: 'noAssignCount',
    color: 'orange',
  },
  {
    text: '纸样',
    val: `currentDesignNodeName${ORDER_NODE_TEXT.PATTERN}`,
    orderCountField: 'patternCount',
    color: 'orangeRed',
  },
  {
    text: '纸样逾期',
    val: `designOrderState${ORDER_NODE_STATUS.PATTERN_OVERDUE}`,
    orderCountField: 'patternOverdueCount',
    color: 'orange',
  },
  {
    text: '车版逾期',
    val: `designOrderState${ORDER_NODE_STATUS.VEHICLE_OVERDUE}`,
    orderCountField: 'sweepOverdueCount',
    color: 'orange',
  },
  {
    text: '进行中',
    val: ORDER_STATUS.PROCESSING,
    orderCountField: 'designInOverdueCount',
    color: 'orange',
    bg: '#FFF3E1',
    tc: '#FB9400',
  },
  {
    text: '已结束',
    val: ORDER_STATUS.COMPLETE,
    color: 'green',
    bg: '#D6F9E7',
    tc: '#04C160',
  },
  {
    text: '废版',
    val: ORDER_STATUS.PAPER_TRASH,
    color: 'gray',
    bg: '#F8F8F9',
    tc: '#6A6C6C',
  },
  {
    text: '撤销',
    val: ORDER_STATUS.REVOKE,
    color: 'gray',
    bg: '#F8F8F9',
    tc: '#6A6C6C',
  },
];
export const TagOptions = [
  {
    text: '未开始',
    val: ORDER_STATUS.DIDNTSTART,
    bg: '#ECF3FF',
    tc: '#007CFF',
    color: 'color-theme',
  },
  // {
  //   text: '待生产',
  //   val: ORDER_STATUS.PROCESSING,
  //   bg: '#FFEFEC',
  //   tc: '#F37C64',
  // },
  {
    val: ORDER_STATUS.AUDITING,
    text: '审批中',
    color: 'orange',
    bg: '#FFF3E1',
    tc: '#FB9400',
  },
  {
    val: ORDER_STATUS.AUDIT_REJECT,
    text: '拒绝',
    color: 'orangeRed',
    bg: '#FFEFEC',
    tc: '#F37C64',
  },
  {
    text: '进行中',
    val: ORDER_STATUS.PROCESSING,
    bg: '#FFF3E1',
    tc: '#FB9400',
    color: 'color-orange',
  },
  // {
  //   text: '头版',
  //   val: ORDER_STATUS.PROCESSING,
  //   bg: '#EDF0FF',
  //   tc: '#6C80ED',
  // },
  // {
  //   text: '复版',
  //   val: ORDER_STATUS.PROCESSING,
  //   bg: '#EDF0FF',
  //   tc: '#6C80ED',
  // },
  {
    text: '废版',
    val: ORDER_STATUS.PAPER_TRASH,
    bg: '#F8F8F9',
    tc: '#6A6C6C',
    color: 'color-gray',
  },
  {
    text: '已结束',
    val: ORDER_STATUS.COMPLETE,
    bg: '#D6F9E7',
    tc: '#04C160',
    color: 'color-green',
  },
  // {
  //   text: '审版通过',
  //   val: ORDER_STATUS.COMPLETE,
  //   bg: '#D6F9E7',
  //   tc: '#04C160',
  // },
  // {
  //   text: '客定',
  //   val: ORDER_STATUS.REVOKE,
  //   bg: '#F8F8F9',
  //   tc: '#6A6C6C',
  // },
  {
    text: '撤销',
    val: ORDER_STATUS.REVOKE,
    bg: '#F8F8F9',
    tc: '#6A6C6C',
    color: 'color-gray',
  },
];
// 打版方式
export const DesignOrderModeOptions = [
  {
    text: '自主打样',
    val: 1,
  },
  {
    text: '外发打样',
    val: 2,
  },
  {
    text: '共同打样',
    val: 3,
  },
];
export const TypeOptions = [
  {
    text: '客订',
    val: 1,
  },
  {
    text: '开发款',
    val: 2,
  },
];

export const reportTypeOptions = [
  {
    label: '新纸样',
    value: 2,
    color: '#409eff',
  },
  {
    label: '改纸样',
    value: 3,
    color: '#31caba',
  },
  {
    label: '放码',
    value: 1,
    color: '#007CFF',
  },
  {
    label: '产前版',
    value: 4,
    color: '#04c160',
  },
];

export const nodeTypeOptions = [
  {
    text: '普通',
    value: 1,
  },
  {
    text: '纸样',
    value: 2,
  },
  {
    text: '车版',
    value: 3,
  },
  {
    text: '审版',
    value: 4,
  },
];

export const defaultNodeData = {
  nodeName: '',
  reportType: '', // 汇报方式
  nodeType: '', // 节点类型
  leaders: {
    leaderIds: [],
    leaderNames: '',
    leaderObj: [],
  },
  finishTime: '',
};

export const listColumns = [
  {
    title: '图片',
    field: 'designOrderImgUrl',
    type: 'image',
    fixed: 'left',
    width: 50,
    showImgPopover: true,
  },
  {
    title: '设计款号',
    field: 'designSn',
    fixed: 'left',
    type: 'slot',
    slotName: 'designSn',
    width: 110,
  },
  {
    title: '样衣名称',
    field: 'designName',
    fixed: 'left',
    align: 'left',
    showTooltip: true,
    width: 110,
  },
  {
    title: '大货号',
    field: 'designGoodsSn',
    width: 110,
  },
  {
    title: '状态',
    field: 'state',
    width: 60,
    render: 'Tag',
    params: TagOptions,
  },
  {
    title: '终版状态',
    field: 'isFinalVersion',
    width: 60,
    formatter: ({ cellValue }: any) => {
      return cellValue ? '终版' : '--';
    },
    hiddenFun: ({ tabActived }: any) =>
      ![
        0,
        ORDER_STATUS.DIDNTSTART,
        ORDER_STATUS.PROCESSING,
        ORDER_STATUS.COMPLETE,
      ].includes(tabActived),
  },
  {
    title: '版次',
    field: 'designOrderSerialName',
    fixed: 'left',
    width: 80,
  },
  {
    title: '工序进度',
    field: 'workProcessList',
    type: 'slot',
    width: 360,
  },
  {
    title: '版单号',
    field: 'designOrderSn',
    width: 80,
  },
  {
    title: '打版数',
    field: 'totalNumber',
    align: 'right',
    width: 80,
  },
  {
    title: '已交付',
    field: 'totalDeliveryNumber',
    align: 'right',
    width: 80,
  },

  {
    title: '设计师',
    field: 'designDesignerName',
    width: 80,
  },
  {
    title: '品牌',
    field: 'designBrandName',
    width: 80,
  },
  {
    title: '季节',
    field: 'designSeasonName',
    width: 80,
  },
  {
    title: '波段',
    field: 'designRangesName',
    width: 80,
  },

  {
    title: '下版日期',
    field: 'businessTime',
    width: 110,
    type: 'day',
    sortable: true,
  },
  {
    title: '预计完成',
    field: 'finishTime',
    width: 110,
    type: 'day',
  },
  {
    title: '齐料状态',
    field: 'materialIssue',
    type: 'slot',
    width: 150,
    slotName: 'materialIssue',
    defaultHidden: true,
  },
  {
    title: '客户',
    field: 'clientName',
    default: '-',
    hidden: !checkAuthority('dataDesignManagerCustomer'),
    width: 80,
  },
  {
    title: '设计助理',
    field: 'designAssistantName',
    default: '-',
    width: 80,
    defaultHidden: true,
  },
  {
    title: '跟单员',
    field: 'followUserName',
    default: '-',
    width: 80,
  },
  {
    title: '备注',
    field: 'remark',
    align: 'left',
    showTooltip: true,
    type: 'slot',
    slotName: 'remark',
    // render: 'Class',
    // params: 'color-red',
  },
  {
    title: '操作',
    field: 'operate',
    fixed: 'right',
    type: 'operate',
    width: 200,
    align: 'left',
  },
];
export default {};
